<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()

const { imageBeautyDetails } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <div v-if="imageBeautyDetails.display" class="col-span-12">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ imageBeautyDetails.title }}
      </template>

      <template #content>
        <SectionsDetailsElementsImages
          :images="details.imageBeautyDetails"
        />
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
